/**
 * Constantes para IDs de módulos de add-on
 * Usados para verificar se a empresa tem acesso a funcionalidades específicas
 */
export const MODULES = {
  WHATSAPP: 'addon.whatsapp',       // Automação Whatsapp (ID: 5)
  NFE: 'addon.nfe',                 // Nota fiscal eletrônica (ID: 6)
  DIGITAL_SIGNATURE: 'addon.digital_signature' // Assinatura eletrônica (ID: 7)
};

/**
 * Mapeamento entre módulos e features da API
 */
export const MODULE_FEATURES = {
  [MODULES.WHATSAPP]: [
    'whatsapp.messages.read',
    'whatsapp.messages.create',
    'whatsapp.messages.update',
    'whatsapp.messages.delete',
    'company.whatsapp_config.read',
    'company.whatsapp_config.update'
  ],
  [MODULES.NFE]: [
    'financial.read',
    'financial.create'
  ],
  [MODULES.DIGITAL_SIGNATURE]: [
    'company.document_templates.read',
    'company.document_templates.create'
  ]
};